// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sy66","rightAdornment":"Header_rightAdornment__1yTYJ"};